/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TraceSearchRouteImport } from './routes/trace-search'
import { Route as TestDatasetsRouteImport } from './routes/test-datasets'
import { Route as SkillToolRouteImport } from './routes/skill-tool'
import { Route as SessionsReviewRouteImport } from './routes/sessions-review'
import { Route as RuntimeClosureRouteImport } from './routes/runtime-closure'
import { Route as QualityRouteImport } from './routes/quality'
import { Route as PromptQRouteImport } from './routes/prompt-q'
import { Route as PlaybookRouteImport } from './routes/playbook'
import { Route as PlanLabRouteImport } from './routes/plan-lab'
import { Route as PipelineTestbenchRouteImport } from './routes/pipeline-testbench'
import { Route as LoopMvpLabRouteImport } from './routes/loop-mvp-lab'
import { Route as KnowledgeRouteImport } from './routes/knowledge'
import { Route as IntentRouteImport } from './routes/intent'
import { Route as HealthRouteImport } from './routes/health'
import { Route as ExternalTestsGuideRouteImport } from './routes/external-tests-guide'
import { Route as ExternalTestsRouteImport } from './routes/external-tests'
import { Route as EvalRouteImport } from './routes/eval'
import { Route as DictionaryRouteImport } from './routes/dictionary'
import { Route as DevConsoleRouteImport } from './routes/dev-console'
import { Route as DebugRouteImport } from './routes/debug'
import { Route as DataFlowMapRouteImport } from './routes/data-flow-map'
import { Route as IndexRouteImport } from './routes/index'

const TraceSearchRoute = TraceSearchRouteImport.update({
  id: '/trace-search',
  path: '/trace-search',
  getParentRoute: () => rootRouteImport,
} as any)
const TestDatasetsRoute = TestDatasetsRouteImport.update({
  id: '/test-datasets',
  path: '/test-datasets',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillToolRoute = SkillToolRouteImport.update({
  id: '/skill-tool',
  path: '/skill-tool',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsReviewRoute = SessionsReviewRouteImport.update({
  id: '/sessions-review',
  path: '/sessions-review',
  getParentRoute: () => rootRouteImport,
} as any)
const RuntimeClosureRoute = RuntimeClosureRouteImport.update({
  id: '/runtime-closure',
  path: '/runtime-closure',
  getParentRoute: () => rootRouteImport,
} as any)
const QualityRoute = QualityRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => rootRouteImport,
} as any)
const PromptQRoute = PromptQRouteImport.update({
  id: '/prompt-q',
  path: '/prompt-q',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaybookRoute = PlaybookRouteImport.update({
  id: '/playbook',
  path: '/playbook',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanLabRoute = PlanLabRouteImport.update({
  id: '/plan-lab',
  path: '/plan-lab',
  getParentRoute: () => rootRouteImport,
} as any)
const PipelineTestbenchRoute = PipelineTestbenchRouteImport.update({
  id: '/pipeline-testbench',
  path: '/pipeline-testbench',
  getParentRoute: () => rootRouteImport,
} as any)
const LoopMvpLabRoute = LoopMvpLabRouteImport.update({
  id: '/loop-mvp-lab',
  path: '/loop-mvp-lab',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeRoute = KnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const IntentRoute = IntentRouteImport.update({
  id: '/intent',
  path: '/intent',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthRoute = HealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => rootRouteImport,
} as any)
const ExternalTestsGuideRoute = ExternalTestsGuideRouteImport.update({
  id: '/external-tests-guide',
  path: '/external-tests-guide',
  getParentRoute: () => rootRouteImport,
} as any)
const ExternalTestsRoute = ExternalTestsRouteImport.update({
  id: '/external-tests',
  path: '/external-tests',
  getParentRoute: () => rootRouteImport,
} as any)
const EvalRoute = EvalRouteImport.update({
  id: '/eval',
  path: '/eval',
  getParentRoute: () => rootRouteImport,
} as any)
const DictionaryRoute = DictionaryRouteImport.update({
  id: '/dictionary',
  path: '/dictionary',
  getParentRoute: () => rootRouteImport,
} as any)
const DevConsoleRoute = DevConsoleRouteImport.update({
  id: '/dev-console',
  path: '/dev-console',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugRoute = DebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => rootRouteImport,
} as any)
const DataFlowMapRoute = DataFlowMapRouteImport.update({
  id: '/data-flow-map',
  path: '/data-flow-map',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/data-flow-map': typeof DataFlowMapRoute
  '/debug': typeof DebugRoute
  '/dev-console': typeof DevConsoleRoute
  '/dictionary': typeof DictionaryRoute
  '/eval': typeof EvalRoute
  '/external-tests': typeof ExternalTestsRoute
  '/external-tests-guide': typeof ExternalTestsGuideRoute
  '/health': typeof HealthRoute
  '/intent': typeof IntentRoute
  '/knowledge': typeof KnowledgeRoute
  '/loop-mvp-lab': typeof LoopMvpLabRoute
  '/pipeline-testbench': typeof PipelineTestbenchRoute
  '/plan-lab': typeof PlanLabRoute
  '/playbook': typeof PlaybookRoute
  '/prompt-q': typeof PromptQRoute
  '/quality': typeof QualityRoute
  '/runtime-closure': typeof RuntimeClosureRoute
  '/sessions-review': typeof SessionsReviewRoute
  '/skill-tool': typeof SkillToolRoute
  '/test-datasets': typeof TestDatasetsRoute
  '/trace-search': typeof TraceSearchRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/data-flow-map': typeof DataFlowMapRoute
  '/debug': typeof DebugRoute
  '/dev-console': typeof DevConsoleRoute
  '/dictionary': typeof DictionaryRoute
  '/eval': typeof EvalRoute
  '/external-tests': typeof ExternalTestsRoute
  '/external-tests-guide': typeof ExternalTestsGuideRoute
  '/health': typeof HealthRoute
  '/intent': typeof IntentRoute
  '/knowledge': typeof KnowledgeRoute
  '/loop-mvp-lab': typeof LoopMvpLabRoute
  '/pipeline-testbench': typeof PipelineTestbenchRoute
  '/plan-lab': typeof PlanLabRoute
  '/playbook': typeof PlaybookRoute
  '/prompt-q': typeof PromptQRoute
  '/quality': typeof QualityRoute
  '/runtime-closure': typeof RuntimeClosureRoute
  '/sessions-review': typeof SessionsReviewRoute
  '/skill-tool': typeof SkillToolRoute
  '/test-datasets': typeof TestDatasetsRoute
  '/trace-search': typeof TraceSearchRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/data-flow-map': typeof DataFlowMapRoute
  '/debug': typeof DebugRoute
  '/dev-console': typeof DevConsoleRoute
  '/dictionary': typeof DictionaryRoute
  '/eval': typeof EvalRoute
  '/external-tests': typeof ExternalTestsRoute
  '/external-tests-guide': typeof ExternalTestsGuideRoute
  '/health': typeof HealthRoute
  '/intent': typeof IntentRoute
  '/knowledge': typeof KnowledgeRoute
  '/loop-mvp-lab': typeof LoopMvpLabRoute
  '/pipeline-testbench': typeof PipelineTestbenchRoute
  '/plan-lab': typeof PlanLabRoute
  '/playbook': typeof PlaybookRoute
  '/prompt-q': typeof PromptQRoute
  '/quality': typeof QualityRoute
  '/runtime-closure': typeof RuntimeClosureRoute
  '/sessions-review': typeof SessionsReviewRoute
  '/skill-tool': typeof SkillToolRoute
  '/test-datasets': typeof TestDatasetsRoute
  '/trace-search': typeof TraceSearchRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/data-flow-map'
    | '/debug'
    | '/dev-console'
    | '/dictionary'
    | '/eval'
    | '/external-tests'
    | '/external-tests-guide'
    | '/health'
    | '/intent'
    | '/knowledge'
    | '/loop-mvp-lab'
    | '/pipeline-testbench'
    | '/plan-lab'
    | '/playbook'
    | '/prompt-q'
    | '/quality'
    | '/runtime-closure'
    | '/sessions-review'
    | '/skill-tool'
    | '/test-datasets'
    | '/trace-search'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/data-flow-map'
    | '/debug'
    | '/dev-console'
    | '/dictionary'
    | '/eval'
    | '/external-tests'
    | '/external-tests-guide'
    | '/health'
    | '/intent'
    | '/knowledge'
    | '/loop-mvp-lab'
    | '/pipeline-testbench'
    | '/plan-lab'
    | '/playbook'
    | '/prompt-q'
    | '/quality'
    | '/runtime-closure'
    | '/sessions-review'
    | '/skill-tool'
    | '/test-datasets'
    | '/trace-search'
  id:
    | '__root__'
    | '/'
    | '/data-flow-map'
    | '/debug'
    | '/dev-console'
    | '/dictionary'
    | '/eval'
    | '/external-tests'
    | '/external-tests-guide'
    | '/health'
    | '/intent'
    | '/knowledge'
    | '/loop-mvp-lab'
    | '/pipeline-testbench'
    | '/plan-lab'
    | '/playbook'
    | '/prompt-q'
    | '/quality'
    | '/runtime-closure'
    | '/sessions-review'
    | '/skill-tool'
    | '/test-datasets'
    | '/trace-search'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DataFlowMapRoute: typeof DataFlowMapRoute
  DebugRoute: typeof DebugRoute
  DevConsoleRoute: typeof DevConsoleRoute
  DictionaryRoute: typeof DictionaryRoute
  EvalRoute: typeof EvalRoute
  ExternalTestsRoute: typeof ExternalTestsRoute
  ExternalTestsGuideRoute: typeof ExternalTestsGuideRoute
  HealthRoute: typeof HealthRoute
  IntentRoute: typeof IntentRoute
  KnowledgeRoute: typeof KnowledgeRoute
  LoopMvpLabRoute: typeof LoopMvpLabRoute
  PipelineTestbenchRoute: typeof PipelineTestbenchRoute
  PlanLabRoute: typeof PlanLabRoute
  PlaybookRoute: typeof PlaybookRoute
  PromptQRoute: typeof PromptQRoute
  QualityRoute: typeof QualityRoute
  RuntimeClosureRoute: typeof RuntimeClosureRoute
  SessionsReviewRoute: typeof SessionsReviewRoute
  SkillToolRoute: typeof SkillToolRoute
  TestDatasetsRoute: typeof TestDatasetsRoute
  TraceSearchRoute: typeof TraceSearchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trace-search': {
      id: '/trace-search'
      path: '/trace-search'
      fullPath: '/trace-search'
      preLoaderRoute: typeof TraceSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-datasets': {
      id: '/test-datasets'
      path: '/test-datasets'
      fullPath: '/test-datasets'
      preLoaderRoute: typeof TestDatasetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skill-tool': {
      id: '/skill-tool'
      path: '/skill-tool'
      fullPath: '/skill-tool'
      preLoaderRoute: typeof SkillToolRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions-review': {
      id: '/sessions-review'
      path: '/sessions-review'
      fullPath: '/sessions-review'
      preLoaderRoute: typeof SessionsReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runtime-closure': {
      id: '/runtime-closure'
      path: '/runtime-closure'
      fullPath: '/runtime-closure'
      preLoaderRoute: typeof RuntimeClosureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quality': {
      id: '/quality'
      path: '/quality'
      fullPath: '/quality'
      preLoaderRoute: typeof QualityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prompt-q': {
      id: '/prompt-q'
      path: '/prompt-q'
      fullPath: '/prompt-q'
      preLoaderRoute: typeof PromptQRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playbook': {
      id: '/playbook'
      path: '/playbook'
      fullPath: '/playbook'
      preLoaderRoute: typeof PlaybookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan-lab': {
      id: '/plan-lab'
      path: '/plan-lab'
      fullPath: '/plan-lab'
      preLoaderRoute: typeof PlanLabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pipeline-testbench': {
      id: '/pipeline-testbench'
      path: '/pipeline-testbench'
      fullPath: '/pipeline-testbench'
      preLoaderRoute: typeof PipelineTestbenchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loop-mvp-lab': {
      id: '/loop-mvp-lab'
      path: '/loop-mvp-lab'
      fullPath: '/loop-mvp-lab'
      preLoaderRoute: typeof LoopMvpLabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge': {
      id: '/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof KnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intent': {
      id: '/intent'
      path: '/intent'
      fullPath: '/intent'
      preLoaderRoute: typeof IntentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health': {
      id: '/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof HealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external-tests-guide': {
      id: '/external-tests-guide'
      path: '/external-tests-guide'
      fullPath: '/external-tests-guide'
      preLoaderRoute: typeof ExternalTestsGuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external-tests': {
      id: '/external-tests'
      path: '/external-tests'
      fullPath: '/external-tests'
      preLoaderRoute: typeof ExternalTestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eval': {
      id: '/eval'
      path: '/eval'
      fullPath: '/eval'
      preLoaderRoute: typeof EvalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dictionary': {
      id: '/dictionary'
      path: '/dictionary'
      fullPath: '/dictionary'
      preLoaderRoute: typeof DictionaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev-console': {
      id: '/dev-console'
      path: '/dev-console'
      fullPath: '/dev-console'
      preLoaderRoute: typeof DevConsoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug': {
      id: '/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof DebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-flow-map': {
      id: '/data-flow-map'
      path: '/data-flow-map'
      fullPath: '/data-flow-map'
      preLoaderRoute: typeof DataFlowMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DataFlowMapRoute: DataFlowMapRoute,
  DebugRoute: DebugRoute,
  DevConsoleRoute: DevConsoleRoute,
  DictionaryRoute: DictionaryRoute,
  EvalRoute: EvalRoute,
  ExternalTestsRoute: ExternalTestsRoute,
  ExternalTestsGuideRoute: ExternalTestsGuideRoute,
  HealthRoute: HealthRoute,
  IntentRoute: IntentRoute,
  KnowledgeRoute: KnowledgeRoute,
  LoopMvpLabRoute: LoopMvpLabRoute,
  PipelineTestbenchRoute: PipelineTestbenchRoute,
  PlanLabRoute: PlanLabRoute,
  PlaybookRoute: PlaybookRoute,
  PromptQRoute: PromptQRoute,
  QualityRoute: QualityRoute,
  RuntimeClosureRoute: RuntimeClosureRoute,
  SessionsReviewRoute: SessionsReviewRoute,
  SkillToolRoute: SkillToolRoute,
  TestDatasetsRoute: TestDatasetsRoute,
  TraceSearchRoute: TraceSearchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
